import React, { Component } from 'react';
import Config from '../config.js';
import { Link as MuiLink, Grid, Card, Typography, withStyles, FormControlLabel, Button, Dialog, Toolbar, MenuItem, DialogContent, DialogActions, IconButton, CardContent, Table, TableBody, TableRow, TableCell, TableHead } from '@material-ui/core';
import axios from 'axios';
import Switch from '../general/switch.js';
import Select from '../general/select_field.js';
import AutoComplete from '../general/fast_suggest_field.js';
import TextField from '../general/text_field.js';
import { Form, Field } from 'react-final-form';
import { getIn } from 'final-form';
import InfoIcon from '@material-ui/icons/Info';
import DragIndicator from '@material-ui/icons/DragIndicator';
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import arrayMutators from 'final-form-arrays';
import createDecorator from 'final-form-calculate'
import { FieldArray } from 'react-final-form-arrays';
import Helper from '../helpers.js';
import Auth from '../auth.js';
import { EventTypes, Categories } from './event_types.js';
import ErrorsCategoryIcon from '../images/errors.svg';
import WarningsCategoryIcon from '../images/warnings.svg';
import InfoCategoryIcon from '../images/info.svg';
import UserIcon from '../images/user.svg';
import ScheduleIcon from '../images/schedule.svg';
import SearchBox from '../general/searchbox.js';
import { Link } from 'react-router-dom';
import EventModal from '../messages/event_modal.js';

const styles = {
    card: {
        display: 'flex',
        flexDirection: 'column',
        '& label': {
            marginBottom: '0.5rem'
        }
    }
};

const reportEventTypes = {
    'ClientActivityReport': [23],
    'DocumentAgingReport': [47],
    'FailedDocumentReport': [30],
    'FuncAckReport': [26],
    'InventoryUnmatchedReport': [41],
    'InventoryUpdateReport': [40, 45],
    'MonthlyDocumentReport': [19, 24],
    'MonthlyOrderReport': [19, 25],
    'NewDocumentActivityReport': [19],
    'OpenDocumentReport': [27],
    'ScoreCardReport': [58],
    'ShippedOrderAgingReport': [47],
    'SubmittedDocumentReport': [27],
    'UnshippedOrderReport': [27]
}

const Draggable = SortableHandle(({children, style}) => (
  <div style={{ cursor: "move", ...style }}>{children}</div>
));


const sortEnd = move => ({ oldIndex, newIndex }) => {
  move(oldIndex, newIndex);
};

const sortStart = ({ node, helper }) => {
      node.childNodes.forEach((td, index) => {
        helper.childNodes[index].style.width = `${td.offsetWidth}px`;
      });
    }

const getTableContainer = () => document.getElementById("fieldTable");

const EventTypeOptions = [<MenuItem key="0" value="">Any event</MenuItem>].concat(EventTypes.Info.concat(EventTypes.Error).concat(EventTypes.Warning)
    .sort((a,b) => a.description > b.description ? 1 : -1)
    .map(r => <MenuItem key={r.id} value={r.id}>{r.description}</MenuItem>));

const getOperators = (field) => {
    let operators = [{label: 'equals', value: 'equals'}, {label: 'does not equal', value: 'not equals'}];
    if(field !== "partner"){
        operators.push({label: 'contains', value: 'contains'});
        operators.push({label: 'does not contain', value: 'not contains'});
    }
    return operators.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>);
}

const IfSet = ({ field, children }) => (
  <Field name={field} subscription={{ value: true }}>
    {({ input: { value } }) => (!(!value) ? typeof children === 'function' ? children({value}) : children : null)}
  </Field>
)

const SortableItem = SortableElement(({ name, fields, value, partnerOptions }) => (
    <TableRow style={{backgroundColor: "white"}}>
    <TableCell padding="checkbox">
        <Draggable style={{display: 'flex', alignItems: 'center', width: '2em', fontSize: '16px'}}><DragIndicator/> {value + 1}</Draggable>
    </TableCell>
    <TableCell>
      <Field component={Select} formControlProps={{style: {width: '100%'}}} name={`${name}.Action`}>
        <MenuItem value="allow">Allow</MenuItem>
        <MenuItem value="block">Block</MenuItem>
      </Field>
    </TableCell>
    <TableCell>
      <Field component={Select} displayEmpty={true} formControlProps={{style: {width: '100%'}}} style={{textAlign: 'left'}} name={`${name}.EventType`}>
      {EventTypeOptions}
      </Field>
    </TableCell>
    <TableCell>
      <Field component={Select} format={v => !v ? "" : v} parse={v => !v ? null : v} displayEmpty={true} formControlProps={{style: {width: '100%'}}} style={{textAlign: 'left'}} name={`${name}.Condition`}>
        <MenuItem value="">Always</MenuItem>
        <MenuItem value="if">If</MenuItem>
      </Field>
    </TableCell>
    <TableCell>
      <IfSet field={`${name}.Condition`}>
          <Field component={Select} formControlProps={{style: {width: '100%'}}} validate={v => (!v)} name={`${name}.Field`}>
            <MenuItem value="partner">Partner</MenuItem>
            <MenuItem value="subject">Subject</MenuItem>
            <MenuItem value="body">Body</MenuItem>
          </Field>
      </IfSet>
    </TableCell>
    <TableCell>
    <IfSet field={`${name}.Condition`}>
    <IfSet field={`${name}.Field`}>
          {({value}) => <Field component={Select} formControlProps={{style: {width: '100%'}}} validate={v => (!v)} name={`${name}.Operator`}>{getOperators(value)}</Field>}
    </IfSet>
    </IfSet>
    </TableCell>
      <TableCell>
        <IfSet field={`${name}.Condition`}>
            <IfSet field={`${name}.Field`}>
              {({value}) => {
                  if(value === 'partner'){
                      return <Field style={{textAlign: 'left', width: '100%'}} validate={v => (!v)} component={AutoComplete} options={partnerOptions} controlled name={`${name}.Value`}/>
                  }
                  return <Field style={{textAlign: 'left', width: '100%'}} validate={v => (!v)} component={TextField} name={`${name}.Value`}/>;
              }}
            </IfSet>
        </IfSet>
      </TableCell>
      <TableCell padding="none" style={{alignSelf: 'center'}}><Button variant='contained' onClick={() => fields.remove(value)}>Remove</Button></TableCell>
    </TableRow>
));

const SortableList = SortableContainer(({ items, partnerOptions, values }) => {
  return (
    <TableBody id="fieldTable">
      {items.map((name, index) => (
        <SortableItem
          key={getIn(values, name + ".key")}
          index={index}
          value={index}
          name={name}
          fields={items}
          partnerOptions={partnerOptions}
        />
      ))}
    </TableBody>
  );
});

const ruleDecorator = createDecorator(
    {
        field: /\.Field/,
        updates: (value, name, allValues, prevValues) => {
            let valueField = name.replace(".Field", ".Value");
            let operatorField = name.replace(".Field", ".Operator");
            let currentField = getIn(allValues, name);
            let prevField = getIn(prevValues, name);
            let currentOperator = getIn(allValues, operatorField);
            let ret = {};
            if(currentField === 'partner' && prevField && prevField !== 'partner'){
                ret[valueField] = null;
                if(currentOperator !== 'equals' && currentOperator !== 'not equals'){
                    ret[operatorField] = 'equals';
                }
            } else if (prevField === 'partner' && currentField !== 'partner'){
                ret[valueField] = null;
            }
            return ret;
        }
    },
    {
        field: /\.Condition/,
        updates: (value, name, allValues, prevValues) => {
            let valueField = name.replace(".Condition", ".Value");
            let operatorField = name.replace(".Condition", ".Operator");
            let fieldField = name.replace(".Condition", ".Field");
            let condition = getIn(allValues, name);
            let ret = {};
            if(!condition){
                ret[valueField] = null;
                ret[operatorField] = null;
                ret[fieldField] = null;
            }
            return ret;
        }
    }
)

class FilterButon extends Component {
    render(){
        let {children, onClick, category, value} = this.props;
        return <Button variant='outlined' color={category === value ? 'primary' : undefined} onClick={() => onClick(value)}>{children}</Button>;
    }
}

class Notifications extends Component {
    state = {notifications: {}, errorDialog: false, verificationDialog: false, confirmUnsubscribe: false, reportDefinitions: [], showEventDetails: false, showError: false, 
    category: Categories.All, term: '', showScheduledDetails: false}
    cancelSource = axios.CancelToken.source();
    async loadNotifications(loadDefinitions){
        let defCall = async () => (await axios.get(Config.api + "/odata/Company/ReportDefinitions?$select=Id,Description,ReportName&$orderby=Description")).data.value;
        let resCall = async () => (await axios.get(Config.api + `/odata/Company/ActivityEventSubscription/?&$select=EventTypeId&$filter=(CrmUserId eq '${Auth.getUserId()}') and IsSubscribed`)).data.value;
        let rulesCall = async () => (await axios.get(Config.api + `/odata/Company/EmailRules`)).data.value || [];
        let partnersCall = async () => (await axios.get(Config.api + '/api/v1/Partners')).data.Body.Partners;
        let partners = [];
        let reportDefinitions = [];
        let res = [];
        let rules = [];
        if(loadDefinitions){
            [reportDefinitions, res, rules, partners] = await Promise.all([defCall(), resCall(), rulesCall(), partnersCall()]);
        }else{
            [res, rules] = await Promise.all([resCall(), rulesCall()]);
        }
        let notifications = {};
        EventTypes.Info.every(r => {notifications["_" + r.id] = false; return true;});
        EventTypes.Error.every(r => {notifications["_" + r.id] = false; return true;});
        EventTypes.Warning.every(r => {notifications["_" + r.id] = false; return true;});
        if(res){
            res.every(r => {notifications["_" + r.EventTypeId] = true; return true;});
        }
        rules.forEach(r => r.key = r.Id);
        let state = {notifications, rules: {Rules: rules}};
        if(loadDefinitions){
            let partnerOptions = partners.map(r => {return {value: r.Id.toString(), label: r.CompanyName}});
            partnerOptions.push({value: this.props.coid.toString(), label: this.props.companyName});
            partnerOptions = partnerOptions.sort((a, b) => a.label.localeCompare(b.label));
            this.setState({...state, reportDefinitions, partnerOptions});
        }else{
            this.setState(state);
        }
    }
    onEventClick = async (event) => {
        this.cancelSource.cancel("Event clicked.");
        this.cancelSource = axios.CancelToken.source();
        let reports = Object.keys(reportEventTypes).filter(k => reportEventTypes[k].indexOf(event.id) >= 0);
        reports = (this.state.reportDefinitions || []).filter(r => reports.indexOf(r.ReportName) >= 0);
        let eventIdReq = axios.get(Config.api + `/odata/Company/VwActivityEvents?$filter=EventTypeId eq ${event.id}&$orderby=Id desc&$top=1`, {
            cancelToken: this.cancelSource.token
        });
        this.setState({showEventDetails: true, event: event, eventReports: reports.map(r => r.Description), eventId: null});
        let eventId = ((await eventIdReq).data.value[0] || {}).Id;
        this.setState({eventId: eventId});
    }
    async componentDidMount(){
        await this.loadNotifications(true);
    }
    onSubmit = async (e) => {
        var evts = Object.keys(e).filter(key => e[key]).map(key => key.substring(1));
        await axios.get(Config.api + `/odata/Company/Functions.SubscribeToEvents?userid=${Auth.getUserId()}&eventIds=${evts.length > 0 ? evts.join(',') : 'null'}&email=${Auth.getEmail()}`);
        this.loadNotifications();
    }
    renderEvents(events){
        let filtered = events.filter(r => (this.state.category === Categories.All || this.state.category === r.category) && (!this.state.term || r.description.toLowerCase().indexOf(this.state.term.toLowerCase()) > -1));
        let notScheduled = filtered.filter(r => !r.scheduled);
        let scheduled = filtered.filter(r => r.scheduled);
        if(filtered.length === 0){
            return <Typography style={{color: "#9E9E9E"}}>No notifications matching your filters.</Typography>
        }
        return <>
            {notScheduled.map(item => {
            return (<div key={"_" + item.id} style={{textAlign: 'left'}}>
                <FormControlLabel style={{height: '1.5em'}} control={<Field type="checkbox" component={Switch} name={"_" + item.id}/>} label={item.description}/>
                <IconButton style={{position: 'absolute', marginLeft: '-12px', marginTop: '-2px'}} color='primary' onClick={() => this.onEventClick(item)} size="small"><InfoIcon fontSize="inherit" /></IconButton>
                </div>)})}
            {scheduled.length > 0 && <>
                <Typography style={{color: "#9E9E9E", fontWeight: 'bold', marginTop: '1em', marginBottom: '0.5em'}}>Scheduled Reports <IconButton color='primary' onClick={() => this.setState({showScheduledDetails: true})} size="small"><InfoIcon fontSize="inherit" /></IconButton></Typography>
                {scheduled.map(item => {
                return (<div key={"_" + item.id} style={{textAlign: 'left'}}>
                    <FormControlLabel style={{height: '1.5em'}} control={<Field type="checkbox" component={Switch} name={"_" + item.id}/>} label={item.description}/>
                    <IconButton style={{position: 'absolute', marginLeft: '-12px', marginTop: '-2px'}} color='primary' onClick={() => this.onEventClick(item)} size="small"><InfoIcon fontSize="inherit" /></IconButton>
                    </div>)})}
            </>}
        </>;
    }
    unsubscribeAll = async () => {
        this.setState({disableUnsubscribe: true});
        await axios.get(Config.api + '/odata/Company/Functions.UnsubscribeAll');
        this.setState({confirmUnsubscribe: false, disableUnsubscribe: false});
        this.loadNotifications();
    }
    onRuleSubmit = async e => {
        let rules = e.Rules.map((r, i) => ({...r, Priority: i + 1}));
        try{
            await axios.post(Config.api + '/odata/Company/Functions.UpdateEmailRules', rules);
            await this.loadNotifications();
        }catch(ex){
            let error = 'An unexpected error occurred.';
            if(ex.response && ex.response.data){
                error = new Helper().getApiErrors(ex.response.data).join("\n")
            }
            this.setState({showError: true, error});
        }
    }
    setCategory = (category) => {
        this.setState({category: category});
    }
    updateTerm = e => {
        this.setState({term: e.currentTarget.value});
    }
    render(){
        let { isBillable } = this.props;
        return (<Grid container spacing={2} style={{padding: "24px 14px 24px 14px"}}>
            <Grid item md={12} sm={12} xs={12} style={{textAlign: 'left', display: 'flex'}}>
                <Typography style={{fontSize: '24px', fontWeight: '600'}}>Notifications</Typography>
                <div style={{flex: 1}}></div>
                {isBillable && <Button component={Link} variant='outlined' to='/settings/monitoring'>Scheduled Reports</Button>}
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
                <Card>
                    <CardContent style={{display: 'flex', gap: '1em', textAlign: 'left', padding: '10px'}}>
                        <FilterButon category={this.state.category} onClick={this.setCategory} value={Categories.All}>All</FilterButon>
                        <FilterButon category={this.state.category} onClick={this.setCategory} value={Categories.Orders}>Order Lifecycle</FilterButon>
                        <FilterButon category={this.state.category} onClick={this.setCategory} value={Categories.Inventory}>Inventory/Product</FilterButon>
                        <FilterButon category={this.state.category} onClick={this.setCategory} value={Categories.Partners}>Partners/Onboarding</FilterButon>
                        <FilterButon category={this.state.category} onClick={this.setCategory} value={Categories.Connectivity}>Connectivity</FilterButon>
                        <div style={{flex: 1}}></div>
                        <SearchBox handleKeyUp={this.updateTerm} handleChange={this.updateTerm} placeholder={'Search'}/>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item sm={12} md={12} lg={12} style={{display: 'flex'}}>
                <Card style={{flex: 1}}>
                    <CardContent className={this.props.classes.card}>
                        <Form onSubmit={this.onSubmit} initialValues={this.state.notifications} render={({ handleSubmit, pristine, invalid }) => {
                              return (
                                  <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', textAlign: 'left'}}>
                                  <Grid container>
                                    <Grid item md={4} style={{display: 'flex', flexDirection: 'column'}}>
                                        <Typography variant="h6" component="h2" style={{marginBottom: '1em', display: 'flex', alignItems: 'center', gap: '10px'}}>Info <img alt='Info' src={InfoCategoryIcon}/></Typography>
                                        {this.renderEvents(EventTypes.Info)}
                                    </Grid>
                                    <Grid item md={4} style={{display: 'flex', flexDirection: 'column'}}>
                                        <Typography variant="h6" component="h2" style={{marginBottom: '1em', display: 'flex', alignItems: 'center', gap: '10px'}}>Errors <img alt='Errors' src={ErrorsCategoryIcon}/></Typography>
                                        {this.renderEvents(EventTypes.Error)}
                                    </Grid>
                                    <Grid item md={4} style={{display: 'flex', flexDirection: 'column'}}>
                                        <Typography variant="h6" component="h2" style={{marginBottom: '1em', display: 'flex', alignItems: 'center', gap: '10px'}}>Warnings <img alt='Warnings' src={WarningsCategoryIcon}/></Typography>
                                        {this.renderEvents(EventTypes.Warning)}
                                    </Grid>
                                  </Grid>
                                  <div style={{width: '100%', textAlign: 'right', marginTop: '1em'}}>
                                      <Button variant='contained' style={{marginRight: '1em'}} onClick={() => this.setState({confirmUnsubscribe: true, disableUnsubscribe: false})}>Unsubscribe from all notifications</Button>
                                      <Button type='submit' disabled={pristine} variant='contained' color='primary'>Save</Button>
                                  </div>
                                  </form>
                              );}}/>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item sm={12} md={12} lg={12}>
                <Card>
                    <CardContent style={{textAlign: 'left'}}>
                    <Typography variant="h6" component="h2">Filters</Typography>
                    <Typography style={{textAlign: 'left'}}>You may configure additional email filtering rules here. Rules will be processed in order from top to bottom. Please be aware that certain types of events such as new order notifications are summarized and cannot be filtered by partner.</Typography>
                    <Form onSubmit={this.onRuleSubmit} initialValues={this.state.rules} mutators={{...arrayMutators}} decorators={[ruleDecorator]} render={({ handleSubmit, pristine, invalid, submitting, values }) => {
                          return (
                              <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column'}}>
                    <FieldArray name="Rules">
                    {({ fields }) => (
                        <>
                        <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell padding="checkbox" style={{width: '3em'}}>Order</TableCell>
                                <TableCell style={{width: '5em'}}>Action</TableCell>
                                <TableCell style={{width: '30em'}}>Notification Type</TableCell>
                                <TableCell style={{width: '8em'}}>Condition</TableCell>
                                <TableCell style={{width: '10em'}}>Field</TableCell>
                                <TableCell style={{width: '10em'}}>Operator</TableCell>
                                <TableCell>Value</TableCell>
                                <TableCell padding="none" style={{width: '8em'}}></TableCell>
                            </TableRow>
                        </TableHead>
                        <SortableList
                          helperClass={'tableDragElement'}
                          helperContainer={getTableContainer}
                          useDragHandle={true}
                          items={fields}
                          values={values}
                          onSortEnd={sortEnd(fields.move)}
                          onSortStart={sortStart}
                          partnerOptions={this.state.partnerOptions}
                        />
                        </Table>
                        <div style={{marginTop: '0.5em', textAlign: 'right'}}>
                            <Button variant='contained' onClick={() => fields.push({ Action: 'block', Condition: 'if', Field: 'partner', Operator: 'equals', key: Math.random().toString(16).slice(2) })} disabled={fields.length >= 100}>Add filter</Button>
                            <Button variant='contained' color='primary' style={{marginLeft: '1em'}} onClick={handleSubmit} disabled={pristine || invalid || submitting}>Save</Button>
                        </div>
                        </>
                      )}
                    </FieldArray>
                    </form>)}}/>
                    </CardContent>
                </Card>
            </Grid>
            <Dialog open={this.state.confirmUnsubscribe} onClose={() => {this.setState({confirmUnsubscribe: false})}}>
                <Toolbar className='lbtoolbar'>Confirm</Toolbar>
                <DialogContent><Typography>{'Are you sure you want to unsubscribe from all Logicbroker notifications?'}</Typography></DialogContent>
                <DialogActions>
                    <Button disabled={this.state.disableUnsubscribe} onClick={() => this.setState({confirmUnsubscribe: false})} color="primary">No</Button>
                    <Button disabled={this.state.disableUnsubscribe} onClick={this.unsubscribeAll} color="primary">Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog open={this.state.showError} onClose={() => {this.setState({showError: false})}}>
                <Toolbar className='lbtoolbar'>{'Error'}</Toolbar>
                <DialogContent><Typography>{this.state.error}</Typography></DialogContent>
            </Dialog>
            <Dialog maxWidth='sm' fullWidth open={this.state.showScheduledDetails} onClose={() => {this.setState({showScheduledDetails: false})}}>
                <Toolbar className='lbtoolbar'>Scheduled Reports</Toolbar>
                <DialogContent>
                    <Typography>Scheduled Reports are automated, recurring reports that provide key data insights to monitor operations, track KPIs, and maintain visibility across trading partner activities.</Typography>
                    <Typography style={{color: '#9E9E9E', marginTop: '1em'}}><img src={UserIcon} alt='Users' style={{marginRight: '10px'}}/><span style={{fontWeight: 'bold'}}>Available to customers only</span> contact <MuiLink href='mailto:sales@logicbroker.com'>sales@logicbroker.com</MuiLink> for more info</Typography>
                </DialogContent>
            </Dialog>
            <Dialog maxWidth='sm' fullWidth open={this.state.showEventDetails} onClose={() => {this.setState({showEventDetails: false})}}>
                <Toolbar className='lbtoolbar'>{(this.state.event || {}).description}</Toolbar>
                <DialogContent>
                    <Typography>{(this.state.event || {}).details}</Typography>
                    <Typography style={{color: '#9E9E9E', marginTop: '1em'}}><img style={{marginRight: '10px'}} src={ScheduleIcon} alt='Schedule'/>{(this.state.event || {}).schedule}</Typography>
                    {this.state.eventReports && this.state.eventReports.length > 0 && <><Typography style={{marginTop: '1em'}}>To receive this notification, enable the report(s) through the Scheduled Reports page:</Typography>
                    <ul style={{margin: 0}}>
                        {this.state.eventReports.map((r, i) => <li key={i}><Typography>{r}</Typography></li>)}
                    </ul></>}
                </DialogContent>
                <DialogActions style={{display: 'flex', justifyContent: 'right'}}>
                    {this.state.eventReports && this.state.eventReports.length > 0 && isBillable && <Button component={Link} variant='outlined' to='/settings/monitoring'>Scheduled Reports</Button>}
                    <Button disabled={!this.state.eventId} variant='outlined' onClick={async () => {await this.setState({previewEventId: null}); await this.setState({previewEventId: this.state.eventId});}}>Preview</Button>
                </DialogActions>
            </Dialog>
            <EventModal eventId={this.state.previewEventId} viewed={true}/>
            </Grid>);
    }
}

export default withStyles(styles)(Notifications);
